import Swiper from "swiper";

const uspSlider = () => {
  const uspSwiper = new Swiper(".js-usp-slider", {
    slidesPerView: "auto",
    slideToClickedSlide: true,
    spaceBetween: 32,
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
      1280: {
        spaceBetween: 80,
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", function () {
  uspSlider();
});
